<template>
    <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-5">
            <div class="row">
                <div class="col-12 text-center">
                    <h1>Simulação de empréstimo</h1>
                </div>
            </div>
            <div class="row">
                <form class="col-12">
                    <div class="form-group">
                        <label class="col-form-label" for="txtValor"><span class="badge badge-pill badge-primary">1</span> Qual o valor do empréstimo?</label>
                        <input type="tel" v-model="valor" class="form-control form-control-lg dinheiro campos" id="txtValor" placeholder="Ex. R$ 70.000" v-mask="'money'">
                    </div>
                    <div class="form-group">
                        <label class="col-form-label" for="ddlPrazo"><span class="badge badge-pill badge-primary">2</span> Qual a quantidade de parcelas?</label>
                        <div class="slider">
                            <at-slider v-model="prazo" :min="6" :max="36" :step="6"></at-slider> 
                        </div>
                        <span class="parcelas">{{ this.prazo }}</span>
                    </div>
                    <div class="form-group">
                        <label class="col-form-label" for="txtFaturamento"><span class="badge badge-pill badge-primary">3</span> Quanto sua empresa faturou nos últimos 12 meses?</label>
                        <input type="tel" v-model="faturamento" class="form-control form-control-lg dinheiro campos" v-mask="'money'" id="txtFaturamento" placeholder="Ex. R$ 100.000">
                    </div>
                    <button type="button" id="btnSimular" class="btn btn-lg btn-primary btn-block" :disabled="!isValid()" @click="getSimulation()">Simular empréstimo</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import HubConsultaClient from '../utils/hub-consulta-client'
import Masker from '@/utils/masker'

    export default {
        data () {
            return {
                valor: null,
                prazo: '12',
                faturamento: null,
                enabled: true,
                type: this.$route.query.type,
                simulator: {},
            }
        },
        methods: {
            getType(){
                let tipo;

                switch (this.type) {
                    case 'EMPPES':
                        tipo = '1';
                        break;

                    case 'EMPVEI':
                        tipo = '2';
                        break;

                    case 'EMIMB':
                        tipo = '3';
                        break;

                    default:
                        tipo = '0';
                        break;
                }

                return tipo
            },
            isValid() {
                return this.valor != null && this.faturamento != null;
            }, 
            getSimulation() {
                let vr = this.arrumaValor(this.valor),
                    n = this.arrumaValor(this.prazo),
                    fat = this.arrumaValor(this.faturamento),
                    tipo = this.getType();

                if(parseFloat(vr) <= 1000 || parseFloat(fat) <= 1000) {
                    this.$Notify.error('O valores devem ser superiores a R$ 1.000,00');
                } else {
                    HubConsultaClient.simulator(vr, n, fat, tipo)
                    .then(data => {
                        this.simulator = data.data;
                        localStorage.setItem('simulatorData', JSON.stringify(this.simulator));
                        localStorage.setItem('loansValue', parseFloat(vr).toFixed(2));
                        localStorage.setItem('fat', parseFloat(fat).toFixed(2));
                        localStorage.setItem('n', n);
                        this.$router.push(`/tipo-de-emprestimo/simulacao-emprestimo?type=${this.type}`);
                    })
                }
            },
            arrumaValor(value) {
                return typeof value == "string" ? Masker.unmaskMoney(value).toString() : value.toString()
            },
            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/tipo-de-emprestimo/simulacao',
                    title: 'simulacao',
                })
            },
        },
        async created() {
            //tagueamento GA
            await this.taggingGA();
        }
    }

</script>

<style lang="scss" scoped>
    @import "../assets/styles/iouu/mixins";
    @import "../assets/styles/iouu/variables";

    h1 {
        @include font-size(30px);
        @include separador(150px, 5px, 30px, 25px, auto, auto, $c3);

        @include xs {
            @include font-size(20px);
            @include separador(120px, 5px, 30px, 25px, auto, auto, $c3);
            margin-top: 100px;
        }
    }

    form {
        width: 100%;

        .badge-pill {
            line-height: 20px;
            padding: 0px;
            width: 20px;
            height: 20px;

            @include xs {
                line-height: 17px;
                width: 17px;
                height: 17px;
            }
        }

        .badge-primary {
            background: $c3;
        }

        label {
            font-size:14px!important;
            color: #000!important;
            text-transform: initial!important;

            @include xs {
                font-size:12px!important;
            }
        }
        .form-group {
            position: relative;

            .slider {
                margin-right: 60px;
            }

            span.parcelas {
                @include font-size(20px);
                font-family: $basefont;
                color: $c5;
                font-weight: bold;
                position: absolute;
                bottom: -8px;
                right:0;
            }

            @include xs {
                .slider {
                    margin-right: 40px;
                }
                span.parcelas {
                    @include font-size(15px);
                    bottom: -6px;
                }

                input {
                    @include font-size(13px);
                }
            }
        }

        .btn-primary.disabled,
        .btn-primary:disabled {
            background-color: #ccc;
            border: none;
            cursor: default;
        }
    }

    @include xs {
        .steps {
            .btn {
                padding-top: 10px;
                padding-bottom: 10px;
                &-primary {
                    font-size: 12px!important;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Simulation.vue